import * as TypeGraphQL from "type-graphql";
export var SystemAlertType;
(function (SystemAlertType) {
    SystemAlertType["PERFORMANCE_DEGRADATION"] = "PERFORMANCE_DEGRADATION";
    SystemAlertType["TRAINING_FAILURE"] = "TRAINING_FAILURE";
    SystemAlertType["DEPLOYMENT_ISSUE"] = "DEPLOYMENT_ISSUE";
    SystemAlertType["DATA_QUALITY"] = "DATA_QUALITY";
    SystemAlertType["RESOURCE_LIMIT"] = "RESOURCE_LIMIT";
    SystemAlertType["GENERAL"] = "GENERAL";
})(SystemAlertType || (SystemAlertType = {}));
TypeGraphQL.registerEnumType(SystemAlertType, {
    name: "SystemAlertType",
    description: undefined,
});
//# sourceMappingURL=SystemAlertType.js.map